// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__51QhN","illustration":"styles_illustration__IdPXQ","title":"styles_title__AGi3S","content":"styles_content__V8hKX","input":"styles_input__e_7In"};